<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-mail" hide-footer id="modal-confirm-mail">
      <h4 class="text-center">
        ¿Está seguro de guardar la 'liga de pago'? El cliente será notificado vía email para proceder al pago.
      </h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="hideConfirmPagoModal">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="guardarHandler">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-pagado" hide-footer id="modal-confirm-pagado">
      <h4 class="text-center">¿Está seguro de que cliente ya realizó el pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="hideConfirmPagadoModal">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="validarHandler">OK</b-button>
    </b-modal>

    <h4 class="cardD">Pago Complementario - Registro en el RPC</h4>
    <div class="mt-4 col-md-8">
      <ValidationProvider
        name="liga_pago"
        rules="required"
        v-slot="{ errors }"
        :custom-messages="{ required: 'La liga de pago es requerida' }"
      >
        <b-form-group label="Liga de pago Openpay" label-for="input-link-pago-complementario">
          <b-input-group class="mt-3">
            <b-input-group-append>
              <b-button
                :variant="isTextCopied ? 'success' : 'secondary'"
                squared
                v-b-tooltip.hover
                title="Copiar"
                @click="copyLinkToClipboard"
              >
                <b-icon v-if="isTextCopied" icon="check"></b-icon>
                <b-icon v-else icon="clipboard"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-input
              id="input-link-pago-complementario"
              :type="'link'"
              v-model="liga_pago"
              :disabled="false"
              placeholder="Link Openpay"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <h4 class="cardD">Concepto(s) de pago</h4>
    <div class="row" v-for="concepto in conceptos_pago" :key="concepto.id">
      <div class="col-md-4">
        <b-form-group label="Concepto" :label-for="`input-concepto-pago-concepto${concepto.id}`">
          <b-form-input
            :id="`input-concepto-pago-concepto${concepto.id}`"
            type="text"
            v-model="concepto.concepto"
            :disabled="false"
            placeholder="Descripción"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Monto" :label-for="`input-concepto-pago-pago${concepto.id}`">
          <b-form-input
            :id="`input-concepto-pago-pago${concepto.id}`"
            type="number"
            v-model="concepto.monto"
            :disabled="false"
            placeholder="Monto"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div class="row mt-4">
      <b-button variant="success" class="btn-fill" size="sm" @click="addConceptoPago" :disabled="false">
        Agregar concepto
      </b-button>
    </div>

    <div class="row mt-1">
      <div class="col-md-6">
        <h4 class="cardD">Total</h4>
      </div>
      <div class="col-md-6">
        <h4 class="cardD">{{ montoTotalConceptosPagoComputed }}</h4>
      </div>
    </div>

    <h4 class="cardD">Datos Openpay</h4>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Fecha de pago" label-for="input-openpay-fecha-pago">
          <b-form-input id="input-openpay-fecha-pago" type="date" v-model="openpayFechaPago" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Método de pago" label-for="input-openpay-metodo-pago">
          <b-form-input id="input-openpay-metodo-pago" type="text" v-model="openpayMetodoPago" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Cantidad pagada" label-for="input-openpay-cantidad-pagada">
          <b-form-input
            id="input-openpay-cantidad-pagada"
            type="number"
            v-model="openpayCantidadPagada"
            :disabled="false"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Factura Adicional" label-for="input-openpay-factura-adicional">
          <b-form-input
            id="input-openpay-factura-adicional"
            type="text"
            v-model="openpayFacturaAdicional"
            :disabled="false"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div class="mt-4">
      <div class="row">
        <div v-if="constitutiva.disabledComplementa === false" class="col-10">
          <b-button class="btn-fill orange-btn bottom2" size="m" :disabled="!liga_pago" @click="openConfirmPagoModal">
            Guardar liga de pago
          </b-button>
        </div>
        <div v-else class="col-10">
          <b-button class="btn-fill orange-btn bottom2" size="m" :disabled="!liga_pago" @click="openConfirmPagoModal">
            Guardar liga de pago
          </b-button>
        </div>
        <div class="col-2">
          <b-button
            variant="success"
            class="btn-fill bottom2"
            size="m"
            :disabled="constitutiva.disabledAccionistas"
            @click="openConfirmPagadoModal"
          >
            Validar Pago
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CotizacionesApi, FuncionesApi, LayoutsApi, ConstitucionSociedadesApi } from "@/api";
import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "DerechosRpc",

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      loading: false,
      isTextCopied: false,

      existeCotizacionComplementaria: false,

      cotizacion_complementaria_id: null,
      cotizacion_complementaria: {},

      monto: 0,
      liga_pago: "",
      conceptos_pago: [],
      openpayFechaPago: "",
      openpayMetodoPago: "",
      openpayCantidadPagada: 0,
      openpayFacturaAdicional: "",
    };
  },

  computed: {
    montoFormatter() {
      return formatCurrency(this.monto);
    },

    montoTotalConceptosPagoComputed() {
      const total = this.conceptos_pago.reduce((total, concepto) => {
        return total + Number.parseInt(concepto.monto);
      }, 0);

      this.monto = total;

      return formatCurrency(total);
    },
  },

  async mounted() {
    if (!this.constitutiva.id_cotizaciones_complementario) {
      this.existeCotizacionComplementaria = false;

      this.addConceptoPago();
      return;
    }

    if (this.constitutiva.id_cotizaciones_complementario) {
      await this.fetchCotizacionComplementaria();

      this.cotizacion_complementaria_id = this.constitutiva.id_cotizaciones_complementario;
      this.cotizacion_complementaria = this.constitutiva.cotizacion_complementaria;
      this.liga_pago = this.cotizacion_complementaria.liga_pago;
      this.conceptos_pago = this.cotizacion_complementaria.conceptos.conceptos_pago;
      this.openpayFechaPago = this.cotizacion_complementaria.conceptos.openpayFechaPago;
      this.openpayMetodoPago = this.cotizacion_complementaria.conceptos.openpayMetodoPago;
      this.openpayCantidadPagada = this.cotizacion_complementaria.conceptos.openpayCantidadPagada;
      this.openpayFacturaAdicional = this.cotizacion_complementaria.conceptos.openpayFacturaAdicional;

      this.existeCotizacionComplementaria = true;
    }
  },

  methods: {
    guardarHandler() {
      this.hideConfirmPagoModal();

      if (!this.existeCotizacionComplementaria) {
        this.createCotizacionComplementaria().then(() => this.guardar());
        return;
      }
    },

    validarHandler() {
      this.cotizacion_complementaria = {
        id: this.cotizacion_complementaria_id,
        precio_total: this.monto,
        liga_pago: this.liga_pago,
        fecha_pago: this.openpayFechaPago,
        conceptos: {
          conceptos_pago: this.conceptos_pago,
          openpayFechaPago: this.openpayFechaPago,
          openpayMetodoPago: this.openpayMetodoPago,
          openpayCantidadPagada: this.openpayCantidadPagada,
          openpayFacturaAdicional: this.openpayFacturaAdicional,
        },
      };

      this.editCotizacionComplementaria()
        .then(() => this.hideConfirmPagadoModal())
        .then(() => this.validar());
    },

    async fetchCotizacionComplementaria() {
      try {
        this.loading = true;
        const cotizacion = await CotizacionesApi.detail(this.constitutiva.id_cotizaciones_complementario);

        this.constitutiva.cotizacion_complementaria = cotizacion;
        this.cotizacion_complementaria = cotizacion;
        this.liga_pago = cotizacion.liga_pago;
        this.conceptos_pago = cotizacion.conceptos.conceptos_pago;
        this.openpayFechaPago = cotizacion.conceptos.openpayFechaPago;
        this.openpayMetodoPago = cotizacion.conceptos.openpayMetodoPago;
        this.openpayCantidadPagada = cotizacion.conceptos.openpayCantidadPagada;
        this.openpayFacturaAdicional = cotizacion.conceptos.openpayFacturaAdicional;
      } catch (error) {
        console.log(error);

        this.$toast.error("Ocurrió un error al cargar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    addConceptoPago() {
      this.conceptos_pago.push({
        id: this.conceptos_pago.length + 1,
        concepto: "",
        monto: 0,
      });
    },

    copyLinkToClipboard() {
      if (!this.liga_pago) {
        return;
      }

      navigator.clipboard.writeText(this.liga_pago).then((this.isTextCopied = true));
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    openConfirmPagoModal() {
      this.$refs["modal-confirm-mail"].show();
    },

    hideConfirmPagoModal() {
      this.$bvModal.hide('modal-confirm-mail');
    },

    openConfirmPagadoModal() {
      this.$refs["modal-confirm-pagado"].show();
    },

    hideConfirmPagadoModal() {
      this.$bvModal.hide('modal-confirm-pagado');
    },

    async createCotizacionComplementaria() {
      const { id } = await CotizacionesApi.create({
        liga_pago: this.liga_pago,
        precio_total: this.monto,
        activo: 1,
        conceptos: {
          conceptos_pago: this.conceptos_pago,
        },
      });

      this.constitutiva.id_cotizaciones_complementario = id;
    },

    async editCotizacionComplementaria() {
      const { id } = await CotizacionesApi.edit(this.cotizacion_complementaria.id, this.cotizacion_complementaria);
    },

    async processPago() {
      try {
        this.$refs["modal-confirm-mail"].hide();

        await ConstitucionSociedadesApi.sendLinkPagoComplementario({
          constitucion_sociedades_id: this.constitutiva.id,
          liga_pago: this.liga_pago,
        });

        this.submitPagoComplementario();

        this.$toast.success("Información guardada", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        this.$toast.error("Ocurrió un error al guardar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }
    },

    processPagado() {
      this.$refs["modal-confirm-pagado"].hide();
      this.validar();
    },

    submitPagoComplementario() {
      this.$emit("saveConstitucion");
    },

    guardar() {
      this.$emit("validaForm", "DerechosRpc", "guardaMonto");
    },

    validar() {
      this.$emit("validaForm", "DerechosRpc", "validaPago");
    },
  },
};
</script>
